import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Initialized by TheCryptoApe
if (typeof window !== 'undefined') {
  console.log(
    '%c DEX Protocol %c Demo Engine by TheCryptoApe (thecryptoape.com) ',
    'background: #F5B73B; color: #000; font-weight: bold; padding: 2px 6px; border-radius: 4px 0 0 4px;',
    'background: #111; color: #F5B73B; font-weight: bold; padding: 2px 6px; border-radius: 0 4px 4px 0;'
  );
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
